import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $filter, $timeout, LocaleService, submissionViewModel, StateUtils) {

    var ctrl = Object.create(BaseCtrl);
    var submissionVM = submissionViewModel();
    var chosenQuoteId = StateUtils.activeDataForState(true).chosenQuote;

    ctrl.init = function () {
        ctrl._setBindDataDefaultValues();
        $scope.policyInfo = {};
        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');

        $scope.policyInfo.billAndPolAddrsEqual = {
            aspects: {
                valid: true,
                required: true,
                subtreeValid: true
            },
            value: true
        };
        $scope.policyInfo.displayAddressArray = $scope.policyInfo.displayAddressArray || submissionVM.baseData.policyAddress.value.displayName.split(',');
        $scope.chosenOffering = _.findWhere(submissionVM.quoteData.offeredQuotes.value, {
            publicID: chosenQuoteId
        });

        $scope.submissionVM = submissionVM;
        $scope.submissionVM.bindData.chosenQuote.value = StateUtils.activeDataForState(true).chosenQuote;
    };

    /**
     * Each time the user selects the 'Yes' option for Billing address being equal to displayed address,
     * Ensure that all of the hidden fields are populated to the same values of the displayed address.
     */
    ctrl.resetBillingAddress = function () {
        if ($scope.policyInfo.billAndPolAddrsEqual.value) {
            angular.copy(submissionVM.baseData.policyAddress.value, submissionVM.bindData.billingAddress.value);
        }
    };

    ctrl._coverages = function (coverages) {
        return coverages.map(function (cov) {
            return {
                name: cov.description,
                amount: cov.amount,
                terms: cov.terms
            };
        });
    };

    ctrl._setBindDataDefaultValues = function () {
        submissionVM.bindData.value = submissionVM.bindData.value || {};
        if (!submissionVM.bindData.billingAddress.value) {
            submissionVM.bindData.billingAddress.value = {};
            angular.copy(submissionVM.baseData.policyAddress.value, submissionVM.bindData.billingAddress.value);
        }
        submissionVM.bindData.contactPhone.value = submissionVM.bindData.contactPhone.value || '';
        submissionVM.bindData.contactEmail.value = submissionVM.bindData.contactEmail.value || submissionVM.baseData.accountHolder.emailAddress1.value;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$filter', '$timeout', 'LocaleService', 'submissionViewModel', 'StateUtils'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/controllers/CPPPolicyInfoCtrl.js
// module id = 826
// module chunks = 0